import { memo } from 'react';

import { Route, Routes, useParams } from 'react-router-dom';

import ReportCellForm from './Form';
import { useReportCellById, useReportCellTypes } from './hooks';
import { ReportCellsList } from './List';

interface Props {
  idVersion: string;
}

const EditCell = () => {
  const { idCell, idVersion } = useParams<Record<string, string>>();

  const { loading, reportCell } = useReportCellById(idVersion ?? '', idCell ?? '');

  const cellType = useReportCellTypes();
  if (reportCell) {
    reportCell.cellType = cellType.find((value) => value.id === reportCell.type);
  }

  return (
    <>
      {!loading && reportCell && (
        <ReportCellForm defaultValue={reportCell} idVersion={idVersion ?? ''} />
      )}
    </>
  );
};

// eslint-disable-next-line react/display-name
export const ReportCells = memo((props: Props) => {
  return (
    <>
      <Routes>
        <Route path="" element={<ReportCellsList idVersion={props.idVersion} />} />
        <Route
          path="create"
          element={<ReportCellForm idVersion={props.idVersion} defaultValue={{}} />}
        />
        <Route path="edit/:idCell" element={<EditCell />} />
      </Routes>
    </>
  );
});
